<script>
  export let label = "";
</script>

<nav class="pager" aria-label={label}>
  <ul>
    <slot />
  </ul>
</nav>
